import { api } from "../../lib/api";

// B5: shared helpers for CRM work panels.
export const errMsg = (e) => e?.response?.data?.detail?.message || e?.response?.data?.detail || "Something went wrong.";
export const toIso = (local) => (local ? new Date(local).toISOString() : null);
export const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const INPUT = "block mt-1 w-full min-h-[44px] rounded border border-erf-borderCream px-3 text-sm bg-white";
export const BTN = "min-h-[44px] px-4 rounded-sm font-semibold text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-erf-dark disabled:opacity-50";

export async function downloadIcs(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([r.data], { type: "text/calendar" }));
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
